<template>
  <v-card>
    <v-card-title>
      Enter a Release# to allocate the material
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            v-model="jobId"
            :label="businessRulesGetBoolean('Jobs Rename to Release') ? 'Release' : 'Job'"
            :items="jobs"
            hide-details="true"
            item-value="id"
            :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
            clearable
            :loading="jobsAreLoading"
          >
            <template #selection="{ item }">
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col class="text-left">
          <v-btn>Attach BOM</v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn>BOM Template</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-file-input v-model="bomFileInput" label="Attached File" />
        </v-col>
      </v-row>

    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="normal" class="mr-2 ml-10" @click="close">
        CLOSE
      </v-btn>
      <v-btn color="primary" @click="submit">
        SUBMIT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import * as allocationApi from '../../../api/InventoryAllocationApi';

export default {
  components: {
  },
  emits: ['allocationInitialized', 'close'],
  data: () => ({
    jobId: null,
    jobs: [],
    jobsAreLoading: false,
    bomFileInput: null,
  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
  },
  watch: {

  },
  created() {
    this.jobsAreLoading = true;
    this.$api.job.readDDL({}).then(res => {
      this.jobs = res;
      this.jobsAreLoading = false;
    });
  },
  methods: {
    async submit() {
      console.log('submit')
      const data = new FormData();
      data.append('bom-file', this.bomFileInput);
      data.append('job-id', this.jobId);
      const res = await allocationApi.createAllocation(data);
      console.log(res)
      this.$emit('allocation-initialized', this.jobId);
    },
    close() {
      //TODO reset
      this.$emit('close');
    }
  },
};
</script>